import { render } from "./DefaultHome.vue?vue&type=template&id=6c8c353c&scoped=true"
const script = {}

import "./DefaultHome.vue?vue&type=style&index=0&id=6c8c353c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8c353c"]])

export default __exports__